module.exports = __webpack_public_path__ + "img/flower-1.ecdf21a2.webp";